<template>
  <section class="d-flex flex-column h-full">
    <div class="flex-grow-1 scroll-y" @scroll="handleScroll">
      <LearnList></LearnList>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import LearnList from "@/components/learn/List";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
    };
  },
  components: {
    TopAppBar,
    LearnList,
  },

  mixins: [topAppBarMixin],

  mounted() {
    if (this.$route.query.status == "LEARNING") {
      this.setTopAppBarBackSearch(this.$t("S10027"));
    } else {
      this.setTopAppBarBackSearch(this.$t("S10026"));
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.status == "LEARNING") {
        this.setTopAppBarBackSearch(this.$t("S10027"));
      } else {
        this.setTopAppBarBackSearch(this.$t("S10026"));
      }
    },
  },

  methods: {
    handleScroll() {
      const subFilterTab = document.querySelector(".primary-sorting");
      subFilterTab.style.backgroundColor =
        subFilterTab.offsetTop > 103 ? "white" : "#fafafa";
    },
  },
};
</script>
